import React from 'react';
import { PaginatorItem } from './PaginatorItem';
export class Paginator extends React.Component {
    constructor() {
        super(...arguments);
        this.pagination = (page, count) => {
            const getRange = (start, end) => {
                return Array(end - start + 1)
                    .fill(0)
                    .map((v, i) => i + start);
            };
            let delta;
            if (count <= 7) {
                // delta === 7: [1 2 3 4 5 6 7]
                delta = 7;
            }
            else {
                // delta === 2: [1 ... 4 5 6 ... 10]
                // delta === 4: [1 2 3 4 5 ... 10]
                delta = page > 4 && page < count - 3 ? 2 : 4;
            }
            const range = {
                start: Math.round(page - delta / 2),
                end: Math.round(page + delta / 2),
            };
            if (range.start - 1 === 1 || range.end + 1 === count) {
                range.start += 1;
                range.end += 1;
            }
            let pages = page > delta
                ? getRange(Math.min(range.start, count - delta), Math.min(range.end, count))
                : getRange(1, Math.min(count, delta + 1));
            const rangeWithDots = (value, pair) => (pages.length + 1 !== count ? pair : [value]);
            if (pages[0] !== 1) {
                pages = rangeWithDots(1, [1, '...']).concat(pages);
            }
            if (pages[pages.length - 1] < count) {
                pages = pages.concat(rangeWithDots(count, ['...', count]));
            }
            return pages;
        };
        this.renderPreviousButton = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("li", null,
                    React.createElement("button", { onClick: () => { var _a, _b; return (_b = (_a = this.props).onChangePage) === null || _b === void 0 ? void 0 : _b.call(_a, Math.max(1, this.props.page - 1)); }, className: 'mx-1 px-1 py-1 rounded-md rounded-l-lg hover:bg-primary-900 focus:outline-none transition-colors duration-150' },
                        React.createElement("svg", { viewBox: '0 0 20 20', className: 'w-4 h-4 fill-current' },
                            React.createElement("path", { clipRule: 'evenodd', fillRule: 'evenodd', d: 'M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z' }))))));
        };
        this.renderNextButton = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("li", null,
                    React.createElement("button", { onClick: () => {
                            var _a, _b;
                            return (_b = (_a = this.props).onChangePage) === null || _b === void 0 ? void 0 : _b.call(_a, Math.min(Math.ceil(this.props.rowCount / this.props.rowsPerPage), this.props.page + 1));
                        }, className: 'mx-1 px-1 py-1 rounded-md rounded-r-lg hover:bg-primary-900 focus:outline-none transition-colors duration-150' },
                        React.createElement("svg", { viewBox: '0 0 20 20', className: 'w-4 h-4 fill-current' },
                            React.createElement("path", { clipRule: 'evenodd', fillRule: 'evenodd', d: 'M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' }))))));
        };
        this.renderDots = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("li", null,
                    React.createElement("span", { className: 'mx-0.5 py-1' }, "..."))));
        };
        this.render = () => {
            const rangeWithDots = this.pagination(this.props.page, Math.ceil(this.props.rowCount / this.props.rowsPerPage));
            const x = (this.props.page - 1) * this.props.rowsPerPage + 1;
            const y = Math.min(this.props.rowCount, (this.props.page - 1) * this.props.rowsPerPage + this.props.rowsPerPage);
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'grid sm:grid-cols-9 px-4 py-3 text-xs font-semibold tracking-wide text-base-400 uppercase bg-base-800 border-t border-base-700' },
                    React.createElement("span", { className: 'flex items-center col-span-3' },
                        x,
                        "-",
                        y,
                        " / ",
                        this.props.rowCount),
                    React.createElement("span", { className: 'col-span-2' }),
                    React.createElement("span", { className: 'flex col-span-4 mt-2 sm:mt-auto sm:justify-end' },
                        React.createElement("nav", null,
                            React.createElement("ul", { className: 'inline-flex items-center' },
                                this.renderPreviousButton(),
                                rangeWithDots.map((value) => {
                                    if (value === '...') {
                                        return this.renderDots();
                                    }
                                    return (React.createElement(PaginatorItem, { key: value, index: value, selected: this.props.page === value, onClick: () => { var _a, _b; return (_b = (_a = this.props).onChangePage) === null || _b === void 0 ? void 0 : _b.call(_a, value); } }));
                                }),
                                this.renderNextButton()))))));
        };
    }
}
